/* Uses the theme's existing product forms and compare selection. */
(() => {
  let frame=0,unique=0;
  const observed=new WeakSet();
  function sync(){
    frame=0;
    let selected=[];
    try{selected=JSON.parse(localStorage.getItem('products-compare')||'[]');}catch(_error){}
    if(document.body.classList.contains('no-compare')!==(selected.length>=4))document.body.classList.toggle('no-compare',selected.length>=4);
    const used=new Set();
    document.querySelectorAll('[id="sort__list"]').forEach(list=>{list.id='bestek-sort-list-'+(++unique);});
    document.querySelectorAll('.js-compare-checkbox').forEach(input=>{
      const wrapper=input.closest('.compare-checkbox');
      if(used.has(input.id)||!input.id){input.id='bestek-compare-'+(++unique);const label=wrapper?.querySelector('label');if(label)label.htmlFor=input.id;}
      used.add(input.id);
      const checked=selected.includes(Number(input.dataset.productId));
      input.checked=checked;
      if(!checked&&input.hasAttribute('checked'))input.removeAttribute('checked');
      if(wrapper?.classList.contains('checked_label')!==checked)wrapper?.classList.toggle('checked_label',checked);
    });
    document.querySelectorAll('.collection-sortby-title:not([role])').forEach(control=>{
      control.setAttribute('role','button');control.tabIndex=0;
      control.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();control.click();}});
    });
    const drawer=document.getElementById('productQuickview'),dock=drawer?.querySelector('.bestek-mobile-quick-actions');
    if(!dock)return;
    const native=drawer.querySelector('.pdp-action-wrapper button[type="submit"]'),proxy=dock.querySelector('button');
    dock.hidden=!native;
    if(native){
      const busy=native.getAttribute('aria-busy')==='true'||!!native.querySelector('[data-btn-loader]')||native.hasAttribute('loading');
      proxy.disabled=native.disabled||busy||native.classList.contains('disabled-button');
      const label=busy?'Adding…':native.textContent.trim()||'Add to cart';
      if(proxy.textContent!==label)proxy.textContent=label;
      if(proxy.getAttribute('aria-busy')!==String(busy))proxy.setAttribute('aria-busy',String(busy));
      if(!observed.has(native)){observed.add(native);new MutationObserver(schedule).observe(native,{attributes:true,childList:true,subtree:true});}
    }
    const url=drawer.querySelector('product-info[data-url]')?.dataset.url,link=dock.querySelector('a');
    if(url&&link.getAttribute('href')!==url)link.href=url;
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(sync);}
  function start(){
    document.querySelector('[data-bestek-quick-add]')?.addEventListener('click',()=>{
      const native=document.querySelector('#productQuickview .pdp-action-wrapper button[type="submit"]');
      if(native&&!native.disabled&&!native.querySelector('[data-btn-loader]')&&!native.classList.contains('disabled-button'))native.click();
    });
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('click',event=>{if(event.target.closest('.compare-checkbox,[data-remove-icon]'))schedule();});
    window.addEventListener('storage',schedule);sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
